import { createContext, useContext, useState, useCallback } from "react";
import { adminT } from "@/lib/adminI18n";

const AdminLangCtx = createContext({ lang: "fr", setLang: () => {}, t: (k) => k });

export function AdminLangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("admin_lang") || "fr");
  const setLang = useCallback((l) => {
    localStorage.setItem("admin_lang", l);
    setLangState(l);
  }, []);
  const t = useCallback((key) => adminT(lang, key), [lang]);
  return <AdminLangCtx.Provider value={{ lang, setLang, t }}>{children}</AdminLangCtx.Provider>;
}

export function useAdminLang() {
  return useContext(AdminLangCtx);
}
